import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  CreatePersonPayload,
  Person,
  PersonDetail,
  PersonFilterParams,
  PersonRecordOrigin,
  PersonsResponse,
  PersonType,
  UpdatePersonPayload,
} from '../../shared/models/person.models';

@Injectable({ providedIn: 'root' })
export class PersonService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/api`;

  getPersons(params: PersonFilterParams = {}) {
    let httpParams = new HttpParams()
      .set('pageSize', params.pageSize ?? 10)
      .set('pageIndex', params.pageIndex ?? 0);
    if (params.filter) httpParams = httpParams.set('filter', params.filter);
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.personTypeCode) httpParams = httpParams.set('personTypeCode', params.personTypeCode);
    if (params.excludePersonTypeCode)
      httpParams = httpParams.set('excludePersonTypeCode', params.excludePersonTypeCode);
    return this.http.get<PersonsResponse>(`${this.base}/persons`, { params: httpParams });
  }

  getPersonById(id: string) {
    return this.http.get<PersonDetail>(`${this.base}/persons/${id}`);
  }

  createPerson(payload: CreatePersonPayload) {
    return this.http.post<Person>(`${this.base}/persons`, payload);
  }

  updatePerson(payload: UpdatePersonPayload) {
    return this.http.put<Person>(`${this.base}/persons`, payload);
  }

  deletePerson(id: string) {
    return this.http.delete<void>(`${this.base}/persons/${id}`);
  }

  getPersonTypes() {
    return this.http.get<PersonType[]>(`${this.base}/person-types`);
  }

  getPersonRecordOrigins() {
    return this.http.get<PersonRecordOrigin[]>(`${this.base}/person-record-origins`);
  }
}
